import { render, staticRenderFns } from "./TPEForm.vue?vue&type=template&id=73610d40&"
import script from "./TPEForm.vue?vue&type=script&lang=js&"
export * from "./TPEForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/production/spf-sexosafe-ezplatform/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('73610d40')) {
      api.createRecord('73610d40', component.options)
    } else {
      api.reload('73610d40', component.options)
    }
    module.hot.accept("./TPEForm.vue?vue&type=template&id=73610d40&", function () {
      api.rerender('73610d40', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/TPEForm/TPEForm.vue"
export default component.exports